import { render, staticRenderFns } from "./project-base.vue?vue&type=template&id=4f28d2b3&"
import script from "./project-base.vue?vue&type=script&lang=ts&"
export * from "./project-base.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports